<template>
  <div>
    <van-nav-bar
      :title="$route.query.vname+' 场馆二维码'"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />

    <van-notice-bar color="#000" background="#ecf9ff" left-icon="volume-o" :scrollable="false">
      <van-swipe
        vertical
        class="notice-swipe"
        :autoplay="3000"
        :show-indicators="false"
      >
        <van-swipe-item key="1">场馆开放时间{{ new Date(parseInt($route.query.openTime)).toLocaleString() }}</van-swipe-item>
        <van-swipe-item key="2">场馆关闭时间{{ new Date(parseInt($route.query.closeTime)).toLocaleString() }}</van-swipe-item>
      </van-swipe>
    </van-notice-bar>

    <van-row type="flex" justify="center" style="margin-top: 50px;">
      <van-col span="30">
        <div id="qrcode" style="border: 5px solid #2980b9;padding: 10px" ref="qrCodeUrl"></div>
      </van-col>
    </van-row>

  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import Vue from 'vue';
import {
  NavBar,
  Toast, Dialog,
  Sticky,
  ActionSheet,
  NoticeBar,
  Row,
  Col,
  Swipe,
  SwipeItem
} from 'vant';

Vue.use(NavBar)
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Sticky);
Vue.use(ActionSheet);
Vue.use(NoticeBar);
Vue.use(Row);
Vue.use(Col);
Vue.use(Swipe);
Vue.use(SwipeItem);
import {ViewVenueQrCode} from "../../../network/venue";

export default {
  name: "VenueQrCode",
  data() {
    return {
      qrcode: null,

      IntervalId: null,

      id: null,
    }
  },
  mounted() {
    this.id = this.$route.query.id;
    // console.log(this.$route.query.refresh);
    this.creatQrCode();
    this.IntervalId = setInterval(() => {
      document.getElementById("qrcode").innerHTML = "";
      this.creatQrCode();
    }, 1000 * parseInt(this.$route.query.refresh));
    // setInterval(() => {
    //   location.reload();
    // }, 1000 * 60)
  },
  destroyed() {
    // console.log(this.IntervalId);
    ViewVenueQrCode(this.id, 1).then(res => {
      // console.log(res);
    })
    clearInterval(this.IntervalId);
    location.reload();
  },
  methods: {
    onClickLeft() {
      this.$router.replace("VenueMList");
    },
    QrCode(text) {
      //let url = 'http://localhost:8090/VenueBooking/vsqc?id=' + this.$route.query.id + '&code=' + text;
      let url = 'http://sports.hhstu.club/VenueBooking/vsqc?id=' + this.$route.query.id + '&code=' + text;
      //let url = 'http://192.168.0.6:8080/VenueBooking/vsqc?id=' + this.$route.query.id + '&code=' + text;
      //console.log(url);
      this.qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: url, // 需要转换为二维码的内容
        width: 235,
        height: 235,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      });
    },
    creatQrCode() {
      ViewVenueQrCode(this.$route.query.id, 0).then(res => {
        this.QrCode(res);
      })
    }

  }
}
</script>

<style scoped>
.notice-swipe {
  height: 40px;
  line-height: 40px;
}
</style>
